var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.authenticated)?_c('div',{staticClass:"ru: ru:admin"},[_c('NavigationAdmin'),_vm._v(" "),_c('div',{staticClass:"ru:admin-container"},[_c('nuxt')],1),_vm._v(" "),_c('PortalTarget',{ref:"stack",staticClass:"ru:stack",attrs:{"name":"stack","multiple":""}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }